import { rem } from 'polished';
import styled, { css } from 'styled-components';

import {
  UpArrowSmallIcon as BaseUpArrowSmallIcon,
  DownArrowSmallIcon as BaseDownArrowSmallIcon,
} from '../../icons';
import { sizeStyles, StyledSizeProps } from '../../styles';
import PopoverContent from '../Popover/PopoverContent';

export const Trigger = styled.div(
  ({ theme }) => css`
    box-sizing: border-box;
    display: flex;
    align-items: center;

    width: max-content;
    max-width: 100%;

    cursor: pointer;

    &:focus-visible {
      outline: 1px solid
        ${theme.semantic.color.interactable.neutral.shadow.strong};
    }
  `,
);

export const Content = styled(PopoverContent)<StyledSizeProps>(({ theme }) => {
  const dropdownList = theme.components.Dropdown.List;

  return css`
    box-sizing: border-box;
    min-width: ${rem(160)};
    max-width: 90vw;
    max-height: ${rem(220)};
    color: ${dropdownList.fg};
    border-radius: ${dropdownList.radius};
    border: 1px solid ${dropdownList.border};
    background-color: ${dropdownList.bg};
    padding: ${theme.core.spacing['4x']} 0;
    box-shadow: none;
    overflow: auto;
    ${sizeStyles}
  `;
});

export const UpArrowSmallIcon = styled(BaseUpArrowSmallIcon)`
  width: 24px;
  height: 24px;
`;

export const DownArrowSmallIcon = styled(BaseDownArrowSmallIcon)`
  width: 24px;
  height: 24px;
`;
